export const csvDownloadHelper = (data, heading, fileName) => {
  return {
    data: data,
    headers: heading,
    filename: fileName + '.csv',
  }
}
